import React, { useEffect, createElement } from 'react';
import { ArrowRightIcon, CalendarIcon, LightbulbIcon, CircleDollarSignIcon, MegaphoneIcon, ImageIcon, SearchIcon, TrendingUpIcon, MonitorIcon, CodeIcon, ServerIcon } from 'lucide-react';
export function KennisbankPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = 'Kennisbank | Website tips & inzichten | Noord';
    let metaDesc = document.querySelector('meta[name="description"]') as HTMLMetaElement;
    if (!metaDesc) {
      metaDesc = document.createElement('meta');
      metaDesc.name = 'description';
      document.head.appendChild(metaDesc);
    }
    metaDesc.content = 'Kennisbank met praktische tips over websites, SEO en online groei. Leer alles over kosten, WordPress, vindbaarheid en meer. Door Noord Digital.';
    // Open Graph meta tags
    const ogTags: Record<string, string> = {
      'og:title': 'Kennisbank | Website tips & inzichten | Noord',
      'og:description': 'Kennisbank met praktische tips over websites, SEO en online groei. Leer alles over kosten, WordPress, vindbaarheid en meer.',
      'og:type': 'website',
      'og:url': 'https://noorddigital.nl/kennisbank',
      'og:site_name': 'Noord Digital',
      'og:locale': 'nl_NL'
    };
    Object.entries(ogTags).forEach(([property, content]) => {
      let tag = document.querySelector(`meta[property="${property}"]`) as HTMLMetaElement;
      if (!tag) {
        tag = document.createElement('meta');
        tag.setAttribute('property', property);
        document.head.appendChild(tag);
      }
      tag.content = content;
    });
  }, []);
  const categories = [{
    title: 'Website tips',
    icon: LightbulbIcon,
    slug: '#/website-tips'
  }, {
    title: 'Website kosten',
    icon: CircleDollarSignIcon,
    slug: '#/kosten-website-laten-maken'
  }, {
    title: 'Website marketing',
    icon: MegaphoneIcon,
    slug: '#/website-marketing'
  }, {
    title: 'Website voorbeelden',
    icon: ImageIcon,
    slug: '#/website-voorbeelden'
  }, {
    title: 'Website SEO',
    icon: SearchIcon,
    slug: '#/kennisbank'
  }];
  const latestArticles = [{
    title: 'Website tips',
    description: 'Praktische tips om je website te verbeteren en meer conversie te behalen.',
    date: '20 feb 2026',
    slug: '#/website-tips',
    image: 'https://images.unsplash.com/photo-1434030216411-0b793f4b4173?w=600&h=400&fit=crop'
  }, {
    title: 'Website voorbeelden',
    description: 'Inspirerende voorbeelden van professionele websites in verschillende sectoren.',
    date: '18 feb 2026',
    slug: '#/website-voorbeelden',
    image: 'https://images.unsplash.com/photo-1522542550221-31fd19575a2d?w=600&h=400&fit=crop'
  }, {
    title: 'Kosten website laten maken',
    description: 'Wat kost een professionele website in 2026? Wij zetten de prijzen op een rij en leggen uit waar je op moet letten.',
    date: '15 feb 2026',
    slug: '#/kosten-website-laten-maken',
    image: 'https://images.unsplash.com/photo-1554224155-6726b3ff858f?w=600&h=400&fit=crop'
  }, {
    title: 'Website laten maken checklist',
    description: 'Alles wat je moet weten voordat je een website laat maken. Van domeinnaam tot content: deze checklist helpt je op weg.',
    date: '8 feb 2026',
    slug: '#/website-laten-maken-checklist',
    image: 'https://images.unsplash.com/photo-1484480974693-6ca0a78fb36b?w=600&h=400&fit=crop'
  }, {
    title: 'WordPress vs Wix',
    description: 'Welk platform past het beste bij jouw bedrijf? We vergelijken WordPress en Wix op prijs, flexibiliteit en SEO.',
    date: '1 feb 2026',
    slug: '#/wordpress-vs-wix',
    image: 'https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=600&h=400&fit=crop'
  }, {
    title: 'Website laten maken of zelf bouwen?',
    description: 'De voor- en nadelen van een professionele website versus zelf bouwen. Ontdek welke optie het beste bij jou past.',
    date: '25 jan 2026',
    slug: '#/website-laten-maken-of-zelf-bouwen',
    image: 'https://images.unsplash.com/photo-1432888498266-38ffec3eaf0a?w=600&h=400&fit=crop'
  }];
  const popularArticles = [{
    title: 'Kosten website laten maken',
    description: 'De complete prijsgids voor 2026.',
    slug: '#/kosten-website-laten-maken',
    reads: '2.4k lezers'
  }, {
    title: 'WordPress vs Wix',
    description: 'Welk platform kies jij?',
    slug: '#/wordpress-vs-wix',
    reads: '1.8k lezers'
  }, {
    title: 'Website laten maken checklist',
    description: 'Vergeet niets met deze checklist.',
    slug: '#/website-laten-maken-checklist',
    reads: '1.5k lezers'
  }];
  const relatedServices = [{
    title: 'Website laten maken',
    description: 'Professionele websites die klanten opleveren.',
    icon: MonitorIcon,
    slug: '#/website-laten-maken'
  }, {
    title: 'WordPress websites',
    description: 'Flexibele WordPress sites met onbeperkte mogelijkheden.',
    icon: CodeIcon,
    slug: '#/wordpress-websites'
  }, {
    title: 'Hosting & onderhoud',
    description: 'Zorgeloos online met snelle, veilige hosting.',
    icon: ServerIcon,
    slug: '#/hosting-onderhoud'
  }];
  return <main className="pt-16 lg:pt-[72px]" data-id="element-1221">
      {/* Hero */}
      <section className="relative py-20 lg:py-28 bg-navy-900 overflow-hidden" data-id="element-1222">
        <div className="absolute inset-0 pointer-events-none" data-id="element-1223">
          <div className="absolute -top-32 -right-32 w-[500px] h-[500px] rounded-full opacity-20 blur-3xl" style={{
          background: 'radial-gradient(circle, #60A5FA 0%, transparent 70%)'
        }} data-id="element-1224" />
          <div className="absolute inset-0 opacity-[0.03]" style={{
          backgroundImage: 'radial-gradient(circle at 1px 1px, white 1px, transparent 0)',
          backgroundSize: '32px 32px'
        }} data-id="element-1225" />
        </div>

        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-1226">
          <p className="text-accent-light font-semibold text-sm tracking-widest uppercase mb-4 animate-fade-in-up" data-id="element-1227">
            Kennisbank
          </p>
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-extrabold text-white mb-6 animate-fade-in-up-delay-1" data-id="element-1228">
            Website tips & inzichten
          </h1>
          <p className="text-lg lg:text-xl text-navy-200 max-w-2xl mx-auto animate-fade-in-up-delay-2" data-id="element-1229">
            Praktische tips en inzichten over websites, SEO en online groei voor
            ondernemers.
          </p>
        </div>
      </section>

      {/* Categorieën */}
      <section className="py-16 bg-white border-b border-navy-100" data-id="element-1230">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1231">
          <div className="flex flex-wrap justify-center gap-4" data-id="element-1232">
            {categories.map(cat => <a key={cat.title} href={cat.slug} className="group flex items-center gap-3 bg-surface-muted hover:bg-accent-light px-5 py-3 rounded-full transition-colors duration-200" data-id="element-1233">
                <cat.icon className="w-4.5 h-4.5 text-accent" data-id="element-1234" />
                <span className="font-medium text-navy-900 text-sm" data-id="element-1235">
                  {cat.title}
                </span>
              </a>)}
          </div>
        </div>
      </section>

      {/* Laatste artikelen */}
      <section className="py-24 bg-surface-muted" data-id="element-1236">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1237">
          <div className="text-center mb-12 lg:mb-16" data-id="element-1238">
            <h2 className="text-3xl lg:text-4xl font-bold text-navy-900 mb-4" data-id="element-1239">
              Laatste artikelen
            </h2>
            <p className="text-lg text-slate-600 max-w-2xl mx-auto" data-id="element-1240">
              De nieuwste tips over website laten maken, SEO en online
              marketing.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-1241">
            {latestArticles.map(article => <a key={article.title} href={article.slug} className="group bg-white rounded-2xl overflow-hidden shadow-soft hover:shadow-medium transition-all duration-300" data-id="element-1242">
                <div className="aspect-[16/10] overflow-hidden" data-id="element-1243">
                  <img src={article.image} alt={article.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" data-id="element-1244" />
                </div>
                <div className="p-5 flex flex-col h-[calc(100%-10rem)]" data-id="element-1245">
                  <div className="flex items-center gap-2 text-xs text-slate-400 mb-2" data-id="element-1246">
                    <CalendarIcon className="w-3.5 h-3.5" data-id="element-1247" />
                    {article.date}
                  </div>
                  <h3 className="text-base font-bold text-navy-900 mb-2 group-hover:text-accent transition-colors leading-snug" data-id="element-1248">
                    {article.title}
                  </h3>
                  <p className="text-slate-600 text-sm leading-relaxed line-clamp-2 flex-grow" data-id="element-1249">
                    {article.description}
                  </p>
                  <span className="inline-flex items-center gap-1.5 text-accent font-semibold text-sm mt-3 group-hover:gap-2.5 transition-all" data-id="element-1250">
                    Lees meer
                    <ArrowRightIcon className="w-4 h-4" data-id="element-1251" />
                  </span>
                </div>
              </a>)}
          </div>
        </div>
      </section>

      {/* Populaire artikelen */}
      <section className="py-24 bg-white" data-id="element-1252">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1253">
          <div className="text-center mb-12 lg:mb-16" data-id="element-1254">
            <div className="inline-flex items-center gap-2 bg-accent-light text-accent font-semibold text-sm px-4 py-1.5 rounded-full mb-4" data-id="element-1255">
              <TrendingUpIcon className="w-4 h-4" data-id="element-1256" />
              Trending
            </div>
            <h2 className="text-3xl lg:text-4xl font-bold text-navy-900 mb-4" data-id="element-1257">
              Populaire artikelen
            </h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-4xl mx-auto" data-id="element-1258">
            {popularArticles.map((article, index) => <a key={article.title} href={article.slug} className="group relative border border-navy-100 rounded-card p-6 hover:border-accent/30 hover:shadow-medium transition-all duration-300" data-id="element-1259">
                <span className="absolute top-4 right-4 text-5xl font-extrabold text-navy-50 leading-none pointer-events-none select-none" data-id="element-1260">
                  {index + 1}
                </span>
                <div className="relative" data-id="element-1261">
                  <span className="text-xs text-slate-400 font-medium" data-id="element-1262">
                    {article.reads}
                  </span>
                  <h3 className="text-lg font-bold text-navy-900 mt-2 mb-2 group-hover:text-accent transition-colors" data-id="element-1263">
                    {article.title}
                  </h3>
                  <p className="text-slate-600 text-sm" data-id="element-1264">
                    {article.description}
                  </p>
                  <span className="inline-flex items-center gap-1.5 text-accent font-semibold text-sm mt-4 group-hover:gap-2.5 transition-all" data-id="element-1265">
                    Lees artikel
                    <ArrowRightIcon className="w-4 h-4" data-id="element-1266" />
                  </span>
                </div>
              </a>)}
          </div>
        </div>
      </section>

      {/* Gerelateerde diensten */}
      <section className="py-24 bg-navy-900 relative overflow-hidden" data-id="element-1267">
        <div className="absolute inset-0 opacity-[0.03] pointer-events-none" style={{
        backgroundImage: 'radial-gradient(circle at 1px 1px, white 1px, transparent 0)',
        backgroundSize: '40px 40px'
      }} data-id="element-1268" />
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1269">
          <div className="text-center mb-12 lg:mb-16" data-id="element-1270">
            <h2 className="text-3xl lg:text-4xl font-bold text-white mb-4" data-id="element-1271">
              Onze diensten
            </h2>
            <p className="text-lg text-navy-300 max-w-2xl mx-auto" data-id="element-1272">
              Naast kennis delen, bouwen wij ook professionele websites.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-1273">
            {relatedServices.map(service => <a key={service.title} href={service.slug} className="group bg-white/[0.06] border border-white/10 rounded-2xl p-8 hover:bg-white/[0.1] transition-all duration-300" data-id="element-1274">
                <div className="w-12 h-12 rounded-xl bg-accent/20 flex items-center justify-center mb-5" data-id="element-1275">
                  <service.icon className="w-6 h-6 text-accent" data-id="element-1276" />
                </div>
                <h3 className="text-lg font-bold text-white mb-2" data-id="element-1277">
                  {service.title}
                </h3>
                <p className="text-navy-300 text-sm mb-4" data-id="element-1278">
                  {service.description}
                </p>
                <span className="inline-flex items-center gap-1.5 text-accent font-semibold text-sm group-hover:gap-2.5 transition-all" data-id="element-1279">
                  Bekijk dienst
                  <ArrowRightIcon className="w-4 h-4" data-id="element-1280" />
                </span>
              </a>)}
          </div>
        </div>
      </section>
    </main>;
}